export default __webpack_public_path__ + "static/media/school-quote.329394e4.jpg";